export const getFirebaseErrorMessage = (errorCode) => {
  switch (errorCode) {
    case "auth/email-already-in-use":
      return "이 이메일은 이미 사용 중입니다. 다른 이메일을 사용해 주세요.";
    case "auth/invalid-email":
      return "이메일 주소가 유효하지 않습니다. 확인하고 다시 시도해 주세요.";
    case "auth/operation-not-allowed":
      return "이메일/비밀번호 계정이 활성화되어 있지 않습니다. 지원팀에 연락해 주세요.";
    case "auth/weak-password":
      return "비밀번호가 너무 약합니다. 더 강력한 비밀번호를 사용해 주세요.";
    default:
      return "예상치 못한 오류가 발생했습니다. 나중에 다시 시도해 주세요.";
  }
};
